import axios, { type AxiosError, type AxiosInstance } from 'axios';
import { ApiError, CancellationError, NetworkError, TimeoutError, ValidationError } from '../types';

export function applyErrorNormalizationInterceptor(client: AxiosInstance): void {
  client.interceptors.response.use(
    (response) => response,
    (
      error: AxiosError<{
        message?: string;
        code?: string;
        retryAfter?: number;
        details?: Record<string, string[]>;
        error?: {
          message?: string;
          code?: string;
          retryAfter?: number;
          details?: Record<string, string[]>;
        };
      }>,
    ) => {
      if (axios.isCancel(error)) {
        return Promise.reject(new CancellationError());
      }

      if (!error.response) {
        if (error.code === 'ECONNABORTED') {
          return Promise.reject(new TimeoutError());
        }
        return Promise.reject(new NetworkError());
      }

      const { status, data } = error.response;
      const envelope = data?.error;
      const message =
        envelope?.message ?? data?.message ?? error.message ?? 'Request failed';
      const code = envelope?.code ?? data?.code;
      const retryAfter = envelope?.retryAfter ?? data?.retryAfter;
      const details = envelope?.details ?? data?.details;

      if (details && Object.keys(details).length > 0) {
        return Promise.reject(new ValidationError(status, message, details));
      }

      return Promise.reject(new ApiError(status, message, code, retryAfter));
    },
  );
}
